<template>
  <div><PageTable /></div>
</template>

<script>
import PageTable from './components/table'
export default {
  name: 'production-defectAnalytics',
  components: { PageTable },
}
</script>
